import {HttpClient, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {ImportNewTransactionsConfig} from "@features/accounts/run-tenant-payouts/model/run-payouts.model";
import {Observable, of, timeout} from "rxjs";
import {catchError} from "rxjs/operators";
import {environment} from "@env/environment";
import {PaymentConfigRequest} from "../../leasing/leasing.model";
import {RetailerTradingReport, TotalTradingReport} from "./trading-report.interface";

@Injectable({
  providedIn: 'root'
})
export class TradingReportService {
  timeOutSecs = 600; // 5 minutes

  constructor(private http: HttpClient) { }

  getRetailerTradingReportForPaymentConfig(paymentConfigUuid: string, startDate: string | null, endDate: string | null): Observable<RetailerTradingReport> {
    let params = new HttpParams();
    if (startDate) params = params.append('startDate', startDate);
    if (endDate) params = params.append('endDate', endDate);
    return this.http.get<RetailerTradingReport>(this.baseTransactUrl + `/${paymentConfigUuid}/retailer`, { params });
  }

  getTotalTradingReportForPaymentConfig(paymentConfigUuid: string, startDate: string | null, endDate: string | null): Observable<TotalTradingReport> {
    let params = new HttpParams();
    if (startDate) params = params.append('startDate', startDate);
    if (endDate) params = params.append('endDate', endDate);
    return this.http.get<TotalTradingReport>(this.baseTransactUrl + `/${paymentConfigUuid}/total`, { params });
  }

  getSharedLeasePaymentConfigs() {
    return this.http.get<PaymentConfigRequest[]>(this.baseTransactUrl + `/payment-config/shared`);
  }

  public importNewTransactions(request: ImportNewTransactionsConfig): Observable<any> {
    return this.callEndpoint( this.baseTransactUrl + `/import`, request);
  }

  public importNewProducts(configId: string): Observable<any> {
    let body: object | null = { correlationId: null, paymentConfigUuid: configId };
    return this.callEndpoint( this.baseProductsUrl + `/import`, body);
  }

  callEndpoint(uri: string, body: object | null) {
    // @ts-ignore
    return this.http.post<any>(uri, body, {responseType: 'text'})
      .pipe(
        timeout(this.timeOutSecs * 1000),
        catchError(e => {
          console.log(e, 'timeout')
          return of(null)
        }));
  }

  get baseTransactUrl(): string {
    return environment.apiTransactHost + '/console/offering/district/accounts/trading-report';
  }

  get baseProductsUrl(): string {
    return environment.apiProductsHost + '/console/offering/district/accounts/trading-report';
  }
}
